export default from './NotAuthenticated';



// WEBPACK FOOTER //
// ./src/views/NotAuthenticated/index.js